import { useTranslation } from "react-i18next";

import type { HaNPersonRelation } from "@lib/logic";
import { Button } from "@molecules";

import { PersonConnectionStatus } from "./PersonConnectionStatus";

type PersonConnectionButtonProps = {
  relation: HaNPersonRelation;

  isSending: boolean;

  onConnect: () => void;

  onAccept: () => void;
};

export const PersonConnectionButton = ({ relation, isSending, onConnect, onAccept }: PersonConnectionButtonProps) => {
  const { t } = useTranslation();

  switch (relation) {
    case "connected":
      return (
        <PersonConnectionStatus
          icon="check"
          label={t("connection:Connected")}
        />
      );

    case "requestSent":
      return (
        <PersonConnectionStatus
          icon="clock"
          label={t("connection:ConnectionRequestSent")}
        />
      );

    case "requestReceived":
      return (
        <Button
          size="small"
          loading={isSending}
          onClick={onAccept}>
          {t("connection:AcceptConnection")}
        </Button>
      );

    case "none":
      return (
        <Button
          size="small"
          loading={isSending}
          onClick={onConnect}>
          {t("connection:Connect")}
        </Button>
      );
  }
};
